<div class="toolbar-notification-container">
  <button mat-icon-button type="button" (click)="toggleDropdown()" [class]="[cssPrefix+'-btn']" [class.open]="isOpen()"
    aria-label="Notificări" aria-haspopup="true" [attr.aria-expanded]="isOpen()">
    <mat-icon [matBadge]="$safeNavigationMigration(notificariLista()?.length)" matBadgeColor="warn" [matBadgeHidden]="notificariLista()?.length === 0"
      [matBadgeDescription]="notificariLista()?.length + ' notificări'">notifications_none</mat-icon>
  </button>

  <div class="dropdown mat-elevation-z1" [class.open]="isOpen()">
    <div class="card">
      <div class="header flex-row flex-align-space-between-center">
        <div class="title">
          <div class="name">Notificări</div>
          <div class="extra">Aveți {{ notificariLista()?.length }} notificări</div>
        </div>
      </div>
      @if (notificariLista().length !== 0) {
        <ng-scrollbar class="content" track="vertical">
          @for (notification of notificariLista(); track notification.mid; let isLast = $last) {
            <div class="notice flex-row flex-align-start-center" mat-ripple>
              @if (notification.body.type === 'transfer') {
                <mat-icon class="icon">check_circle</mat-icon>
              }
              @if (notification.body.type !== 'transfer') {
                <mat-icon class="icon">notifications</mat-icon>
              }
              <button type="button" class="title flex-col" (click)="itemAction($event, notification)">
                <span class="name">{{ notification.body.subject }}</span>
                <span class="time">{{ notification.msg_from }}</span>
              </button>
              <span class="flex-auto"></span>
              <button type="button" mat-icon-button (click)="delete($event, notification)" aria-label="Șterge notificarea">
                <mat-icon class="close">delete</mat-icon>
              </button>
            </div>
            @if (!isLast) {
              <div class="divider"></div>
            }
          }
        </ng-scrollbar>
      } @else {
        <div class="no flex-row flex-align-center-center">Nici o notificare</div>
      }
      <div class="footer flex-row flex-align-center-center">
        <button type="button" class="action" (click)="refresh()">Actualizează lista notificărilor</button>
      </div>
    </div>
  </div>
</div>



